
/* injects from baggage-loader */

import React, { Component } from "react";
import { t } from "../../../helpers/translator";
import { UIMixin } from "../../../mixins/uiMixin";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class LockTerminal extends Component {
  render() {
    const { data = -1 } = this.props;
    const isCustomErrorExists = t(`terminal_error_${data}`) !== `terminal_error_${data}`;

    return (
      <div className="ticket-results-view-p">
        <div
          className="popup-message error"
          onClick={this.props.openPopup("LoginForm", {
            disable: true,
            signInToAdmin: true,
            from: "lockTerminal",
            data: this.props.data,
          })}
        />
        <h3>
          {isCustomErrorExists
            ? t(`terminal_error_${data}`)
            : t(`Sorry, the terminal is currently unavailable ({1})`, data)}
        </h3>
      </div>
    );
  }
}

LockTerminal.propTypes = {
  openPopup: PropTypes.func,
  data: PropTypes.string,
};

export default connect()(UIMixin({ Component: LockTerminal }));
